import type { WithLoadingIndicatorFunction } from '@ipfabric/ui-components/utils/loading/withLoadingIndicator';
import type {
  SecuritySchemaCommandContext,
  SecuritySchemaState,
} from 'components/SecuritySchema/model/SecuritySchemaModel';
import { withCommandModelLoadingIndicator } from 'utils/loading/withCommandModelLoadingIndicator';

export const withSecuritySchemaLoadingIndicator = <TResult,>(
  cmdContext: SecuritySchemaCommandContext,
): WithLoadingIndicatorFunction<TResult> =>
  withCommandModelLoadingIndicator<SecuritySchemaState, TResult>(
    cmdContext,
    'loadingState',
  );
